import { Autocomplete, Box, Button, Checkbox, Chip, FormControlLabel, Grid, IconButton, InputLabel, Paper, Switch, TextField, ThemeProvider, ToggleButton, ToggleButtonGroup, Tooltip, Typography, createTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import LogoImage from "assets/img/logo.png"
import AvahTransparent from 'assets/img/avah_tranparent .png'
import { getYear } from 'date-fns'
import './index.scss'
import { useMobileResponsive } from 'hooks/useMobileResponsive'
import CreateTextFields from 'components/common/Textfield'
import URL from 'url/apiURL'
import { useFetch, useFetchFunction } from 'hooks/useFetch'
import { getCities, getStates, requiredTextfield } from 'utils/customFunctions'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import ForgotPassword from './Components/ForgotPassword'
import FilepondImageUploader  from 'components/common/FilePondImageUploader'
import axios from 'axios'
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import CloseIcon from '@mui/icons-material/Close';
import { SuccessLoader } from './Components/SuccessLoader'
// import { FilepondImageUploader } from 'components/common/FilePondImageUploader'
const {getAllCitiesPerState,getAllBrandsMultiSelect} = URL.LOGIN_REGISTER

const RaeesLoginComponent = () => {
    const [formData, setFormData] = useState({isBrandError:false,success:false,error:false});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const {snackbar,loadingIndicator,fetchData} = useFetchFunction()
    const [login,setLogin] = useState(true)
    const [activeButton, setActiveButton] = useState('customer');
    const currentYear = getYear(new Date());
    const {isMobile} = useMobileResponsive()
    const location = useLocation();
    const navigate = useNavigate()
    const isAdminPage = location.pathname.includes('/admin');
    const {data:cityData} = useFetch(getAllCitiesPerState)
    const [citiesAndState, setCitiesAndState] = useState({ state: [], cities: [] })
    const [forgotPassword, setForgotPasssword] = useState(false)
    const [files, setFiles] = useState({})
    const [fileError,setFileError] = useState(false)
    const [fileRequiredError,setFileRequiredError] = useState(false)
    // OTP login flow state
    const [otpSent, setOtpSent] = useState(false)
    const [devCode, setDevCode] = useState('')
    // OTP register flow state
    const [regOtpSent, setRegOtpSent] = useState(false)
    const [regDevCode, setRegDevCode] = useState('')
    console.log(fileRequiredError)
    const {data:multiSelectBusinessData} = useFetch(getAllBrandsMultiSelect)
    let mappedBrandName = multiSelectBusinessData?.data?.map((val)=>val?.value)

    // const form = new FormData()

    const handleFileChange = (e)=>{
        setFiles(e.target.files[0])
    }
    //TO GET ALL THE STATES
    useEffect(() => {
        if (cityData?.result?.length) {
            let listOfStates = getStates(cityData?.result)
            setCitiesAndState({ state: listOfStates })
        }
    }, [cityData])

    //TO GET CITIES BASED ON SELECTED STATE
    useEffect(() => {
        if (formData.state) {
            let citiesList = getCities(formData.state, cityData?.result)
            setCitiesAndState((prev) => ({ ...prev, cities: citiesList }))
        }
    }, [formData.state])

    const handleButtonClick = (buttonText) => {
        setFormData({})
        setOtpSent(false)
        setDevCode('')
        setRegOtpSent(false)
        setRegDevCode('')
        setActiveButton(buttonText);
      };

    const handleFieldChange = (fieldName, value) => {
        setFormData((prevData) => ({ ...prevData, [fieldName]: value }));
    };

    // Turning RSA off clears the RSA-only fields so no stale radius/24x7 lingers
    // in the payload (the backend ignores them too, but this keeps the UI honest).
    const handleRsaToggle = (checked) => {
        setFormData((prev) => ({
            ...prev,
            rsa_enabled: checked,
            ...(checked ? {} : { service_radius_km: '', is_24x7: false, radiusError: false }),
        }))
    };

    // Which OTP endpoints + role kind apply to the active tab / admin page.
    const otpEndpointsForRole = () => {
        const r = isAdminPage ? 'admin' : activeButton; // 'customer' | 'service provider' | 'admin'
        if (r === 'admin') return { send: URL.AUTH.admin_send_otp, verify: URL.AUTH.admin_verify_otp, kind: 'admin' }
        if (r === 'service provider') return { send: URL.AUTH.vendor_send_otp, verify: URL.AUTH.vendor_verify_otp, kind: 'vendor' }
        return { send: URL.AUTH.customer_send_otp, verify: URL.AUTH.customer_verify_otp, kind: 'customer' }
    }

    // OTP login — step 1 sends the code to the mobile number, step 2 verifies it.
    const loginFunction = async () => {
        const ep = otpEndpointsForRole()
        setIsSubmitted(true)

        if (!otpSent) {
            if (!formData?.phone) { setTimeout(() => setIsSubmitted(false), 1500); return }
            const res = await fetchData({ url: ep.send, method: 'POST', payload: { phone: formData.phone } })
            if (res?.data?.sent) {
                setOtpSent(true)
                if (res.data.devCode) setDevCode(String(res.data.devCode)) // dev/mock mode only
            }
            setIsSubmitted(false)
            return
        }

        // step 2 — verify OTP
        if (!formData?.otp) { setTimeout(() => setIsSubmitted(false), 1500); return }
        const { data } = await fetchData({ url: ep.verify, method: 'POST', payload: { phone: formData.phone, code: formData.otp } })
        if (data?.token) {
            const u = data.user || {}
            localStorage.setItem('access_tokenSP', data.token)
            localStorage.setItem('profile_name', u.name || '')
            if (ep.kind === 'admin') {
                localStorage.setItem('TYPE_OF_USER', '1')
                localStorage.setItem('role', 'Administrator')
                localStorage.setItem('isLoggedIn', 'true')
                setTimeout(() => navigate('/admin/home'), 0)
            } else if (ep.kind === 'vendor') {
                localStorage.setItem('TYPE_OF_USER', '2')
                localStorage.setItem('role', u.role || 'Service Provider')
                localStorage.setItem('sp_id', u.vendorId)
                localStorage.setItem('business_name', u.name || '')
                localStorage.setItem('permission_granted', 'All') // vendor owner (vendor_admin) gets full sidebar access
                localStorage.setItem('isLoggedInSP', 'true')
                setTimeout(() => { navigate('/serviceProvider/home'); navigate(0) }, 0)
            } else {
                localStorage.setItem('TYPE_OF_USER', '3')
                localStorage.setItem('role', 'Customer')
                localStorage.setItem('customer_id', u.customerId)
                localStorage.setItem('customer_email', u.email || '')
                localStorage.setItem('isLoggedInSP', 'true')
                setTimeout(() => navigate('/customer/dashboard'), 0)
            }
            setOtpSent(false); setDevCode(''); setFormData({})
        }
        setIsSubmitted(false)
    }

    const registerFunction = async(e)=>{
        e?.preventDefault()
        let payload ={...formData,role:activeButton,approval_status:false,sp_status:"inactive",email:formData?.email?.toLowerCase()}
        setIsSubmitted(true)
        let isRequired = requiredTextfield(registerTextfield,formData)
        // console.log(payload.role)
        if(payload.role==='service provider'){
            // Service radius is mandatory only when the SP offers RSA — an RSA
            // vendor with no radius would never match a roadside request.
            const rsaRadiusMissing = formData?.rsa_enabled && (formData?.service_radius_km === '' || formData?.service_radius_km == null || Number(formData?.service_radius_km) <= 0)
            if(rsaRadiusMissing){
                setFormData((prev)=>({...prev, radiusError:true}))
                setTimeout(()=>setFormData((prev)=>({...prev, radiusError:false})), 2500)
                setTimeout(()=>setIsSubmitted(false), 2000)
                return
            }
            // console.log(isRequired,files,formData?.serviced_brands)
            if(isRequired || !files?.name || files?.type!=='application/pdf' || formData?.serviced_brands?.length===0 || !formData?.serviced_brands) {
                // console.log(isRequired,files,formData?.serviced_brands)
                if(isRequired){
                    setTimeout(() => {
                        setIsSubmitted(false)
                    }, [2000]);
                }
                if(formData?.serviced_brands?.length===0 || !formData?.serviced_brands){
                    setFormData((prev)=>({...prev,isBrandError:true}))
                    setTimeout(() => {
                        setFormData((prev)=>({...prev,isBrandError:false}))
                      }, [2000])
                    // return
                }
                // console.log(files,!files?.name)
                if(files?.name && files?.type!=='application/pdf'){
                    setTimeout(() => {
                        setFileError(false)
                        // setFiles({})
                    }, [2000])
                    setFileError(true)
                    // return
                }
                else if(!files?.name){
                    console.log('yes')
                    setFileRequiredError(true)
                    setTimeout(()=>{setFileRequiredError(false)},2000)
                }
                // setFileError(false)
                // setFileRequiredError(false)
                return
            }
        }
        else{
            console.log('cust')
            if(isRequired){
                setTimeout(() => {
                    setIsSubmitted(false)
                }, [2000]);
                return
            }
        }
        // if(isRequired || (!files?.name || files?.type!=='application/pdf') || formData?.serviced_brands?.length===0 || !formData?.serviced_brands) {
        //     if(payload.role==='service provider'){
        //         if(formData?.serviced_brands?.length===0 || !formData?.serviced_brands || files?.type!=='application/pdf'){
        //             console.log(formData?.serviced_brands)
        //             if(formData?.serviced_brands?.length===0 || !formData?.serviced_brands){
        //                 setFormData((prev)=>({...prev,isBrandError:true}))
        //                 setTimeout(() => {
        //                     setFormData((prev)=>({...prev,isBrandError:false}))
        //                   }, [2000])
        //                 // return
        //             }
        //             if(files?.name && files?.type!=='application/pdf'){
        //                 setTimeout(() => {
        //                     setFileError(false)
        //                     // setFiles({})
        //                 }, [2000])
        //                 setFileError(true)
        //                 // return
        //             }
        //             else if(!files?.name){
        //                 setFileRequiredError(true)
        //                 setTimeout(()=>{setFileRequiredError(false)},2000)
        //             }
        //             else {
        //                 setFileError(false)
        //                 setFileRequiredError(false)
        //             }
        //             // return
        //         }
        //     }
            // CUSTOMER
            // else{
            //     if(isRequired){
            //         setTimeout(() => {
            //             setIsSubmitted(false)
            //         }, [2000]);
            //         return
            //     }
            // } 
            // setTimeout(() => {
            //     setIsSubmitted(false)
            // }, [2000]);      
            // return
        // }


        const isSP = payload.role === 'service provider'
        // Sign-up OTP-verifies the mobile before creating the account.
        const phone = isSP ? formData.business_contact : formData.phone
        if(!phone){ setTimeout(()=>setIsSubmitted(false),1500); return }

        // Step 1 — send the sign-up OTP to the mobile number.
        if(!regOtpSent){
            const sendUrl = isSP ? URL.AUTH.vendor_register_otp : URL.AUTH.customer_register_otp
            const res = await fetchData({url:sendUrl, method:'POST', payload:{ phone }})
            if(res?.data?.sent){ setRegOtpSent(true); if(res.data.devCode) setRegDevCode(String(res.data.devCode)) }
            setIsSubmitted(false)
            return
        }
        // Step 2 — verify OTP + create the account.
        if(!formData?.otp){ setTimeout(()=>setIsSubmitted(false),1500); return }

        if(isSP){
            const fd = new FormData()
            fd.append('business_document', files)
            const spPayload = {...payload, code: formData.otp}
            for(let key in spPayload){
                if(key==='serviced_brands') fd.append(key, JSON.stringify(spPayload[key]))
                else fd.append(key, spPayload[key])
            }
            try{
                const {data} = await axios.post(URL.AUTH.vendor_register, fd, {headers:{'Content-Type':'multipart/form-data'}})
                if(data?.registered){
                    setFormData({success:true,error:false})
                    setTimeout(()=>{ setFormData({}); setRegOtpSent(false); setRegDevCode(''); setFiles({}); setLogin(true) },2500)
                }
            }catch(err){ setFormData((p)=>({...p,error:true})); setTimeout(()=>setFormData({}),2500) }
        } else {
            const {data} = await fetchData({url:URL.AUTH.customer_register, method:'POST',
                payload:{ name:formData.name, email:formData.email?.toLowerCase(), phone, code:formData.otp }})
            if(data?.token){ // account created + auto-logged-in
                const u = data.user || {}
                localStorage.setItem('access_tokenSP', data.token)
                localStorage.setItem('TYPE_OF_USER','3'); localStorage.setItem('role','Customer')
                localStorage.setItem('customer_id', u.customerId); localStorage.setItem('customer_email', u.email||'')
                localStorage.setItem('profile_name', u.name||''); localStorage.setItem('isLoggedInSP','true')
                setRegOtpSent(false); setRegDevCode(''); setFormData({})
                setTimeout(()=>navigate('/customer/dashboard'),0)
            }
        }
        setIsSubmitted(false)
        // setFormData({})
        setTimeout(()=>setFormData({}),2000)
    }
    let loginTextfield = [
        {
            label:"Name",
            name:"name",
            type:"text",
            fullWidth:true,
            required:true,
            errormessage:'Name is Required'

        },
        {
            label:"Email",
            name:"email",
            type:"text",
            fullWidth:true,
            required:true,
            errormessage:'Email is Required'

        },
        // Password removed — customer sign-up + login are OTP-based now.
    ]

    const businessTypes = [
        {
            label:'Sole Proprietorship',
            value:'Sole Proprietorship'
        },
        {
            label:'Partnership',
            value:'Partnership'
        },
        {
            label:'Limited Liability Partnership',
            value:'Limited Liability Partnership'
        },
        {
            label:'Private Limited Companies',
            value:'Private Limited Companies'
        },
        {
            label:'Public Limited Companies',
            value:'Public Limited Companies'
        },
        {
            label:'One-Person Companies',
            value:'One-Person Companies'
        },        
        {
            label: 'Section 8 Company',
            value: 'Section 8 Company'
        },
        {
            label:'Joint-Venture Company',
            value:'Joint-Venture Company'
        }
      ];

    let registerTextfield = [
        {
            label:"Your Name",
            name:"name",
            type:"text",
            required:true,
            errormessage:'Name is Required'
        },
        {
            label:"Email ID",
            name:"email",
            type:"email",
            required:true,
            errormessage:'Email is Required'
        },
        {
            label:"Business Type",
            name:"business_type",
            type:"text",
            select:true,
            selectArray:businessTypes,
            required:true,
            errormessage:'Select Business Type'
        },
        {
            label:"Business Name",
            name:"business_name",
            type:"text",
            required:true,
            errormessage:'Business Name is Required'
        },
        {
            label:"Business Contact Number",
            name:"business_contact",
            type:"number",
            required:true,
            fullWidth: true,
            errormessage:'Business Contact is Required'
        },
        {
            label:"Business Address",
            name:"business_address",
            type:"text",
            row:2,
            multiline:true,
            required:true,
            errormessage:'Address is Required'
        }, 
        {
            label: 'State',
            name: "state",
            type: 'text',
            fullWidth: true,
            select:true,
            selectArray:citiesAndState?.state,
            size:true,
            required:true,
            errormessage:'Select State'
        },
        {
            label: 'City',
            name: "city",
            type: 'text',
            fullWidth: true,
            select:true,
            selectArray:citiesAndState?.cities,
            size:true,
            required:true,
            errormessage:'Select City'
        },   
        {
            label:"Pincode",
            name:"pin_code",
            type:"number",
            required:true,
            fullWidth: true,
            errormessage:'Please Enter Your Pincode'
        },
        // Password removed — sign-up + login are OTP-based now, so a password is redundant.
    ]


  return (
    <>  
    {/* This is a floating Navbar */}
    {isAdminPage ?
        // IF YOURE IN ADMIN PAGE
        isMobile?
            // FOR MOBILE PUT THE LOGO IN CENTER
            <Box><img src={LogoImage} alt="logo Img" /></Box>
            :
            //FOR LAPTOP PUT IT IN A DIFFERENT PLACE
            <Box className='floating-navbar-container'>
                <Grid className='thick-container'></Grid>
                <Grid className='navbar-floating-img-container'>
                    <img src={LogoImage} alt="logo Img" />
                </Grid>
            </Box>
        :
        //IF YOURE  IN REGULAR PAGE IE=> NOT ADMIN AND ONLY IF NOT IN MOBILE THEN SHOW
        !isMobile && (
            <Box className='floating-navbar-container'>
                <Grid className='thick-container'></Grid>
                <Grid className='navbar-floating-img-container'>
                    <Link to={'/'}><img src={LogoImage} alt="logo Img" /></Link>
                </Grid>
                <Box className='sticky-navbar-container'>
                <Box className="navbar-flex">
                    <Box><Link to={'/'}>Home</Link></Box>
                            <Box>
                                <Box><Link to={'/aboutUs'}>About Us</Link></Box>
                                {/* <Box > */}
                                {/* Coined from a Sanskrit word "<span className="purple">A Vahan</span> ". The founder had a vision to open a garage out of passion for cars. <br/> He had experienced a lack of services for discontinued vehicles and found it very difficult to find the right service executive for the same. Though local mechanics were an option, how to identify and be assured that he is the right guy for your vehicle service? Every startup originates from a problem faced by the public but the solution to that problem lies in the answer of an entrepreneur and there came a vision which was to provide transparency and clarity and connect car owners to their right service provider.<br/> The unauthorized service market is very huge and that's where the founder saw the opportunity to set up a link between car owners and local mechanics. There are a lot of gray areas and no record when and where vehicles are maintained by the car owner through unauthorized local mechanics and there is no accountability for the same. Believing to just have trust in your mechanic and hand over your second home won't suffice this solution when it comes to driving that vehicle on a daily basis.<br/> We need a setup to look into the same and strengthen that trust into reality as this is the need of the current situation. This platform is the solution that caters to the problem rather than an obstacle which we face on our daily chores. Consider it as a medicine from a certified and recognized place which has no room for ambiguity. */}
                                {/* </Box> */}
                            </Box>

                            <Box><Link to={'/whatWeDo'}>What we do</Link></Box>
                            <Box><button onClick={()=>{setLogin(!login);setFormData({});setFiles({});setFileError(false);setFileRequiredError(false);setOtpSent(false);setDevCode('');setRegOtpSent(false);setRegDevCode('')}}>{login?'SIGN UP':"LOGIN"}</button></Box>
                        </Box>
                    {/* </> */}
                </Box>
            </Box>
        )
                
    }
    <Grid container className='login'>
        <Grid item className="left-side-container">
            {
                // THIS IS LOGIN FOR CUSTOMER, DEALER, SERVICE PROVIDER, ADMIN AND REGISTER FOR CUSTOMER
                login || (!login && activeButton =='customer')
                    ?
                        <Box className='form-container'>
                       <Grid container className='login-form'>

                            {/* ONLY SHOW IF ITS IN MOBILE VIEW FOR LOGO AND BUTTON AND DONT SHOW IF ITS IN ADMIN*/}
                            {isMobile && (
                            <Box className='mobile-logo-sign-up'>
                                <Box>{isAdminPage ? <></>:<Link to={'/'}><img src={LogoImage} alt="logo Img" ></img></Link>}</Box>
                                <Box>{isAdminPage ? <></>: <button style={{width:'100px'}} onClick={()=>{setLogin(!login);setFormData({});setFiles({});setFileError(false);setFileRequiredError(false);setOtpSent(false);setDevCode('');setRegOtpSent(false);setRegDevCode('')}} className='black-button'>{login?'SIGN UP':"LOGIN"}</button>}</Box>
                            </Box>
                            )}

                            {/* ONLY SHOW IF LOGIN */}
                            {isAdminPage ? <></> : login  && (
                            <Box className='three-buttons'>
                                <button className={activeButton==='customer'?'active':'inactive'} onClick={()=>handleButtonClick('customer') }>Customer</button>
                                <button className={activeButton==='service provider'?'active':'inactive'} onClick={()=>handleButtonClick('service provider')}>Service Provider</button>
                                {/* <button  className={activeButton==='dealers'?'active':'inactive'}onClick={()=>handleButtonClick('dealers')}>Dealer</button> */}
                            </Box>
                            )}
                            {forgotPassword ?
                                <ForgotPassword goBack={()=>setForgotPasssword(false)} user={isAdminPage ?'admin': activeButton==='customer' ?'customer' : activeButton==='service provider'? 'serviceProvider':isAdminPage ?'admin':''}/>
                                :
                                <>
                                    <Box className='welcome'>{login ? 'Welcome back' : 'Welcome'}</Box>
                                    <Box className='enter-details'>{login ? (otpSent ? 'Enter the OTP sent to your mobile number' : 'Enter your mobile number to receive an OTP') : 'Enter your credentials to register'}</Box>
                                    <Box className='textfields'>
                                        <Box className='smaller-container'>
                                            <CreateTextFields
                                              fields={login
                                                ? (otpSent
                                                    ? [{label:'Mobile Number', name:'phone', type:'number', fullWidth:true, required:true, errormessage:'Mobile number is required'},
                                                       {label:'Enter OTP', name:'otp', type:'number', fullWidth:true, required:true, errormessage:'OTP is required'}]
                                                    : [{label:'Mobile Number', name:'phone', type:'number', fullWidth:true, required:true, errormessage:'Mobile number is required'}])
                                                : (regOtpSent
                                                    ? [...loginTextfield.slice(0,2), {label:'Mobile Number', name:'phone', type:'number', fullWidth:true, required:true, errormessage:'Mobile number is required'}, ...loginTextfield.slice(2), {label:'Enter OTP', name:'otp', type:'number', fullWidth:true, required:true, errormessage:'OTP is required'}]
                                                    : [...loginTextfield.slice(0,2), {label:'Mobile Number', name:'phone', type:'number', fullWidth:true, required:true, errormessage:'Mobile number is required'}, ...loginTextfield.slice(2)])}
                                              formField={formData} onChange={handleFieldChange} isSubmitted={isSubmitted} />
                                            {((login && otpSent && devCode) || (!login && regOtpSent && regDevCode)) ? (
                                              <Box className='enter-details' style={{color:'#b30059', marginTop:8}}>Dev OTP: {login ? devCode : regDevCode}</Box>
                                            ) : null}
                                            {login && otpSent ? (
                                              <Box><Button color='options' onClick={()=>{ setOtpSent(false); setDevCode(''); }}>Change number / resend</Button></Box>
                                            ) : null}
                                            <Box className='signup-register-button'><Button onClick={login ? loginFunction : registerFunction}>{login ? (otpSent ? 'VERIFY & LOGIN' : 'SEND OTP') : (regOtpSent ? 'VERIFY & REGISTER' : 'SEND OTP')}</Button></Box>
                                        </Box>
                                    </Box>
                                </>
                            }


                       </Grid>
                       </Box>
                    :
                    // YOURE IN REGISTER, THIS IS FOR DEALER OR SERVICE PROVIDER ,SINCE ADMIN DONT HAVE AND CUSTOMER COVERED INSIDE THE LOGIN
                        
                        <Box className='register-container'>
                        <form onSubmit={registerFunction}>

                            {isMobile && (
                            <Box className='mobile-logo-sign-up'>
                                <Box>{isAdminPage ? <></>:<Link to={'/'}><img src={LogoImage} alt="logo Img" ></img></Link>}</Box>
                                <Box>{isAdminPage ? <></>: <button onClick={()=>{setLogin(!login);setFormData({});setFiles({});setFileError(false);setFileRequiredError(false);setOtpSent(false);setDevCode('');setRegOtpSent(false);setRegDevCode('')}} className='black-button'>{login?'SIGN UP':"LOGIN"}</button>}</Box>
                            </Box>
                            )}
                            <Box className='welcome'>Welcome {activeButton==='service provider'?'Service Provider':activeButton==='dealers'?'Dealer':''}</Box>
                            <Box className='first-row'>
                                <CreateTextFields fields={registerTextfield.slice(0,1)} formField={formData} onChange={handleFieldChange} isSubmitted={isSubmitted}/>
                                <Box>
                                    <InputLabel sx={{ mb: 1 }}>Brand Service*</InputLabel>
                                    <Autocomplete
                                    freeSolo
                                    autoComplete
                                    multiple
                                    id="fixed-tags-demo"
                                    value={ formData?.serviced_brands}
                                    options={mappedBrandName || []}
                                    onChange={(event, value) =>setFormData((prevData) => ({ ...prevData, ['serviced_brands']: value }))} 
                                    // onSelect={(e,v)=>console.log(e,v,'raees')}
                                    getOptionLabel={(option)=>option}
                                    renderTags={(tagValue, getTagProps) =>
                                        tagValue.map((option, index) => (
                                        <Chip
                                            label={option|| ''}
                                            {...getTagProps({ index })}
                                        />
                                        ))
                                    }
                                    renderInput={(params) => (
                                        <TextField 
                                        {...params} 
                                        size='small'                                 
                                        error={formData?.isBrandError}
                                        helperText={formData?.isBrandError ? 'Must Select One Brand Atleast' : ''}/>
                                    )}

                                    />
                                </Box>

                            </Box>
                            <Box className='second-row'>
                                <CreateTextFields fields={registerTextfield.slice(1,3)} formField={formData} onChange={handleFieldChange} isSubmitted={isSubmitted}/>
                            </Box>
                            <Box className='third-row'>
                                <CreateTextFields fields={registerTextfield.slice(3,5)} formField={formData} onChange={handleFieldChange} isSubmitted={isSubmitted}/>
                            </Box>
                            <Box className='fourth-row'>
                                <CreateTextFields fields={registerTextfield.slice(5,6)} formField={formData} onChange={handleFieldChange} isSubmitted={isSubmitted}/>
                            </Box>
                            <Box className='fifth-row'>
                                <CreateTextFields fields={registerTextfield.slice(6,8)} formField={formData} onChange={handleFieldChange} isSubmitted={isSubmitted}/>
                            </Box>
                            <Box className='sixth-row'>
                                <CreateTextFields fields={registerTextfield.slice(8,9)} formField={formData} onChange={handleFieldChange} isSubmitted={isSubmitted}/>
                                <Box className='input-container'>
                                      <InputLabel sx={{color:'black', marginBottom:1}}>
                                        Business Document
                                        <Tooltip title={'Only pdf files are supported'}>
                                            <IconButton size="small">
                                            <QuestionMarkIcon sx={{fontSize:16}}/>
                                            </IconButton>
                                        </Tooltip>
                                      </InputLabel>
                                      <Box className='inputy'>
                                        <input id='inputy'  type='file' className='fileInput' name='business_document' onChange={handleFileChange}></input>
                                        {files?.name && <Box onClick={()=>{ setFiles({}); document.getElementById('inputy').value='' }} ><CloseIcon/></Box>}
                                      </Box>
                                      {(fileError || fileRequiredError) ?<Box className='redError'><InputLabel>{fileError ? 'Only Pdf files are supported' : 'File is required'}</InputLabel></Box>:<></>}
                                </Box>         
                            </Box>
                            {/* RSA / availability — service radius & 24x7 only apply when RSA is on;
                                business hours apply to any SP and are hidden when 24x7. */}
                            <Box className='rsa-row' sx={{ display:'flex', flexDirection:'column', gap:1.5, my:1 }}>
                                <Box sx={{ display:'flex', alignItems:'center' }}>
                                    <FormControlLabel
                                        control={<Switch color='options' checked={!!formData?.rsa_enabled} onChange={(e)=>handleRsaToggle(e.target.checked)} />}
                                        label='Provides Roadside Assistance (RSA)?'
                                    />
                                    <Tooltip title="RSA (Road Side Assistance) — on-location help for stranded customers: breakdowns, flat tyre, jump-start, towing. Enable this if you can send help to a customer's location.">
                                        <IconButton size='small'><QuestionMarkIcon sx={{fontSize:16}}/></IconButton>
                                    </Tooltip>
                                </Box>

                                {formData?.rsa_enabled && (
                                    <Box sx={{ display:'flex', gap:2, flexWrap:'wrap', alignItems:'flex-start' }}>
                                        <Box sx={{ flex:1, minWidth:180 }}>
                                            <InputLabel sx={{ mb:1, color:'black' }}>Service Radius (km)*</InputLabel>
                                            <TextField
                                                type='number' size='small' fullWidth
                                                value={formData?.service_radius_km ?? ''}
                                                onChange={(e)=>handleFieldChange('service_radius_km', e.target.value)}
                                                error={!!formData?.radiusError}
                                                helperText={formData?.radiusError ? 'Required when RSA is enabled' : 'How far you can travel to a stranded customer'}
                                                inputProps={{ min:1, max:200 }}
                                            />
                                        </Box>
                                        <Box sx={{ pt:3.5 }}>
                                            <FormControlLabel
                                                control={<Switch color='options' checked={!!formData?.is_24x7} onChange={(e)=>handleFieldChange('is_24x7', e.target.checked)} />}
                                                label='Available 24×7'
                                            />
                                        </Box>
                                    </Box>
                                )}

                                {!(formData?.rsa_enabled && formData?.is_24x7) && (
                                    <Box sx={{ display:'flex', gap:2, flexWrap:'wrap' }}>
                                        <Box sx={{ flex:1, minWidth:150 }}>
                                            <InputLabel sx={{ mb:1, color:'black' }}>Opens At</InputLabel>
                                            <TextField type='time' size='small' fullWidth
                                                value={formData?.business_open ?? ''}
                                                onChange={(e)=>handleFieldChange('business_open', e.target.value)}
                                                inputProps={{ step:300 }} />
                                        </Box>
                                        <Box sx={{ flex:1, minWidth:150 }}>
                                            <InputLabel sx={{ mb:1, color:'black' }}>Closes At</InputLabel>
                                            <TextField type='time' size='small' fullWidth
                                                value={formData?.business_close ?? ''}
                                                onChange={(e)=>handleFieldChange('business_close', e.target.value)}
                                                inputProps={{ step:300 }} />
                                        </Box>
                                    </Box>
                                )}
                            </Box>

                            {/* Password row removed — SP sign-up is OTP-based, no password needed. */}
                            <Box className='eigth-row'>
                                {regOtpSent && (
                                  <CreateTextFields fields={[{label:'Enter OTP', name:'otp', type:'number', fullWidth:true, required:true, errormessage:'OTP is required'}]} formField={formData} onChange={handleFieldChange} isSubmitted={isSubmitted}/>
                                )}
                                {regOtpSent && regDevCode ? (<Box className='enter-details' style={{color:'#b30059', marginTop:8}}>Dev OTP: {regDevCode}</Box>) : null}
                            </Box>
                            <Box className='ninth-row'>
                                <button type='submit'>{regOtpSent ? 'VERIFY & REGISTER' : 'SEND OTP'}</button>
                            </Box>
                            </form>
                        </Box>
                        

            }

            {/* THIS EXIST FOR ALL */}
            <Box className='login-footer'>
                <Box className="left-footer">© {currentYear} Made with Love By <Box component={'span'} className='purple'>AVAHAN Services</Box></Box>
                {/* ONLY SHOW IF NOT IN MOBILE VIEW */}
                {/* {!isMobile && (
                <Box className="right-footer">
                    <Box mr={2}>About Us</Box>
                    <Box mr={2}>Terms & Conditions</Box>
                    <Box mr={2}>FAQ's</Box>
                    <Box mr={2}>Privacy Policy</Box>
                    <Box mr={2}>Contact Us</Box>
                </Box>)} */}
            </Box>
        </Grid>
        {/* THIS IS RIGHT SIDE CONTAINER */}
        <Grid item className="right-side-container">
            <img src={AvahTransparent} alt="" />
        </Grid>
    </Grid>
    {snackbar}
    {loadingIndicator}
    {(formData.success || formData?.error) && <SuccessLoader success={formData?.success}/>}
    </>

  )
}

export default RaeesLoginComponent